import React from "react";
import PropTypes from "prop-types";

const TitleHeader = ({ title }) => (
    <nav className="navbar">
        <span className="navbar-brand h4">{title}</span>
    </nav>
);

TitleHeader.propTypes = {
    title: PropTypes.string
};

TitleHeader.defaultProps = {
    title: ""
};

export default TitleHeader;

